import styled from 'styled-components';

const menuBtnSize = '50px';
const menuBtnSizeReduced = '45px';

export const LocationContainer = styled.div`
  background: transparent;
  display: ${(props) => (props.hideBottomButtons ? 'none' : 'block')};
  position: absolute;
  z-index: 2;
  align-items: center;
  bottom: ${(props) => props.alturaBtnLocation}px;
  right: 0;
  padding: 0 10px;
  margin-bottom: 10px;

  @media screen and (max-width: 768px) {
    bottom: calc(${(props) => props.alturaBtnLocation}px + 5px);
  }
`;

export const LocationWrapper = styled.div``;

export const LocationBtnWrapper = styled.div`
  display: flex;
  text-align: center;
  padding: 0;
  margin: 0;
  width: 100%;
  @media screen and (max-width: 768px) {
    height: ${(props) => props.alturaLocationBtnWrapper + 20 + 'px'};
  }
`;

export const LocationIconBtn = styled.button`
  border-radius: 50%;
  height: ${menuBtnSizeReduced};
  width: ${menuBtnSizeReduced};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  margin: auto;
  /* padding: 0; */
  z-index: 2;
  background-color: #666666;

  @media screen and (max-width: 768px) {
    height: ${menuBtnSize};
    width: ${menuBtnSize};
  }

  :active {
    background-color: #febf00;
  }

  :active:after {
    background-color: #666666;
  }
`;
